import { render, staticRenderFns } from "./ModalTabs.vue?vue&type=template&id=7e209b93&"
import script from "./ModalTabs.vue?vue&type=script&lang=ts&"
export * from "./ModalTabs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports